import { render, staticRenderFns } from "./ProcessDocuments.vue?vue&type=template&id=4cecdc10&scoped=true"
import script from "./ProcessDocuments.vue?vue&type=script&lang=js"
export * from "./ProcessDocuments.vue?vue&type=script&lang=js"
import style0 from "./ProcessDocuments.vue?vue&type=style&index=0&id=4cecdc10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cecdc10",
  null
  
)

export default component.exports